export const expensesListArray = [
  {
    id: "11b81baf-82f4-4e1c-9310-474d7bafac7f",
    type: "expense",
    name: "Home Rent",
    amount: -800,
    category: "Bills"
  },
  {
    id: "0ccca680-15ca-49c3-bb5b-13f97679660a",
    type: "expense",
    name: "Electricity",
    amount: -170,
    category: "Bills"
  },
  {
    id: "fdcba35f-22f0-49e6-8c8c-9ca04afb2c00",
    type: "expense",
    name: "Restaurant Dinner",
    amount: -220,
    category: "Bills"
  },
  {
    id: "fdcba15f-22f0-29e6-8c8c-9ca04afb2c00",
    type: "expense",
    name: "Javascript Book",
    amount: -60,
    category: "Bills"
  },
  {
    id: "fdc3a15f-22f0-29e6-8r8c-9cap4afb2c00",
    type: "expense",
    name: "Angular Course",
    amount: -120,
    category: "Bills"
  }
];
